import { render, staticRenderFns } from "./legal-agreement.vue?vue&type=template&id=66554e64&scoped=true&"
import script from "./legal-agreement.vue?vue&type=script&lang=js&"
export * from "./legal-agreement.vue?vue&type=script&lang=js&"
import style0 from "./legal-agreement.vue?vue&type=style&index=0&id=66554e64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66554e64",
  null
  
)

export default component.exports